import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3aae718e")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_2 = { class: "button" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  class: "collapsible-content",
  ref: "contentEl"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_toggle_button = _resolveComponent("base-toggle-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["collapsible", { toggled: _ctx.toggled }])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_base_toggle_button, {
        toggled: _ctx.toggled,
        onToggled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('expand')), 1)
        ]),
        toggled: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('collapse')), 1)
        ]),
        _: 1
      }, 8, ["toggled"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "title", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "content", {}, undefined, true)
    ], 512)
  ], 2))
}